export default __webpack_public_path__ + "static/media/sign-horizontal.de60e764.png";